import PropTypes from 'prop-types';
import { useActionOutputs } from 'automation-ui-action-features/action-outputs/actionOutputHooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const OutputTypeDefinitionPropType = PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({
  typeDefinition: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    label: PropTypes.string
  })
})));

// TODO: Change this to `HybridFlow` once automation-ui-flow cleanup is done

export function wireActionOutputs(WrappedComponent, {
  flow
} = {}) {
  return props => {
    const {
      instanceOutputsByActionId,
      allOutputsByActionTypeId,
      isActionOutputsLoading,
      refetch,
      error
    } = useActionOutputs(flow || props.flow);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      instanceOutputsByActionId: instanceOutputsByActionId,
      allOutputsByActionTypeId: allOutputsByActionTypeId,
      isActionOutputsLoading: isActionOutputsLoading,
      refetchOutputs: refetch,
      outputsFetchError: error
    }));
  };
}